import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import IndexPage from './views/Index.vue'
import store from './store/index.js'

Vue.use(Router)

// lazy-loaded
function loadView(path) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `${path}`)
}


const router = new Router({
	mode: process.env.NODE_ENV == 'development' ? 'hash' : 'history',
	// base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'IndexPage',
			component: IndexPage
		},
		{
			path: '/comic',
			name: 'commic',
			component: loadView("./views/CommicList.vue"),
		},
		{
			path: '/comic_section',
			name: 'commicSection',
			component: loadView("./views/CommicSection.vue"),
		},
		{
			path: '/comic_detail',
			name: 'commicDetail',
			component: loadView("./views/CommicDetail.vue"),
		},
		{
			path: '/prereward',
			name: 'Prereward',
			component: loadView("./pages/home/Prereward02.vue")
		},
		{
			path: '/policy',
			name: 'policy',
			component: loadView("./views/policy.vue")
		},
		{
			path: '/probability',
			name: 'probability',
			component: loadView("./views/probability.vue")
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: loadView("./views/privacy.vue"),
			children: [
                {
                    path: ":date",
                    name: "privacys",
                    component: loadView("./views/privacy.vue"),
                },
            ]
		},
		{
			path: '/camp01',
			name: 'Camp01',
			component: loadView("./pages/cv/Camp01.vue")
		},
		{
			path: '/camp02',
			name: 'Camp02',
			component: loadView("./pages/cv/Camp02.vue")
		},
		{
			path: '/camp03',
			name: 'Camp03',
			component: loadView("./pages/cv/Camp03.vue")
		},
		{
			path: '/camp04',
			name: 'Camp04',
			component: loadView("./pages/cv/Camp04.vue")
		},
		{
			path: '/camp05',
			name: 'Camp05',
			component: loadView("./pages/cv/Camp05.vue")
		},
		{
			path: '/camp06',
			name: 'Camp06',
			component: loadView("./pages/cv/Camp06.vue")
		},
		{
			path: '/camp07',
			name: 'Camp07',
			component: loadView("./pages/cv/Camp07.vue")
        },
        {
			path: '/fankit',
			name: 'fankit',
            component: loadView("./views/Fankit.vue"),
            children: [
                {
                    path: "/",
                    name: "FankitIndex",
                    component: loadView("./pages/fankit/index.vue"),
                },
                {
                    path: "precautions",
                    name: 'Precautions',
                    component: loadView("./pages/fankit/Precautions.vue"),
                },
                {
                    path: "guidelines",
                    name: "Guidelines",
                    component: loadView("./pages/fankit/Guidelines.vue"),
                }
            ]
		},
		{
			path: '/gift',
			name: 'gift',
			component: loadView("./views/Gift.vue")
		}
	]
})

router.beforeEach(async(to, from, next) => {
	if(from.name === 'IndexPage' && to.name !== null) {
        // 离开首页
		if(store.state.Home.FULLPAGE) {
			store.state.Home.FULLPAGE.fullScrollDisable(true)
            store.state.Home.FULLPAGE.bodyScrollable(true)
		}
	}
	next();
})

export default router